import { Box, Fab, Tooltip } from '@mui/material'
import { KeyboardArrowLeft } from '@mui/icons-material'
import React from 'react'
import { StepperControls } from '../../../components/StepperTypes/StepperTypes'
import { stepEnum } from '../enum'

interface PreviousStepProps {
  controls: StepperControls
  specificStep?: number
}

export const PreviousStep: React.FC<PreviousStepProps> = ({
  controls,
  specificStep
}) => {
  const goToPreviousStep = () => {
    specificStep && specificStep > stepEnum.asnSearch
      ? controls.goToStep(specificStep, controls.currentState)
      : specificStep === stepEnum.asnSearch
      ? controls.goToInitialStep()
      : controls.goToPreviousStep(controls.currentState)
  }
  return (
    <Box
      component='div'
      display='flex'
      flexDirection='row'
      flexWrap='nowrap'
      alignItems='left'
      width='10%'
      alignSelf='start'
    >
      <Tooltip title='Volver' aria-label='back'>
        <Fab
          onClick={() => goToPreviousStep()}
          aria-label='Regresar'
          style={{
            position: 'absolute',
            borderRadius: '50%',
            height: '40px',
            width: '40px',
            minWidth: '40px',
            minHeight: '40px',
            zIndex: 1
          }}
        >
          <KeyboardArrowLeft />
        </Fab>
      </Tooltip>
    </Box>
  )
}
